import CustomSelect, { CustomSelectItem } from "../CustomSelect";
import { BCMSDate } from "@bcm-dev/bcms-vite";

/**
 * @function DateRangeCustomSelect
 * @return {React.Component}
 * @exported true
 * @description Custom select for "Date Range".
 */
export default function DateRangeCustomSelect(props) {
    const onChange = value => {
        const dataObj = getDateRangeObj(value);
        if(props.onChange) props.onChange(dataObj);
    };

    return (
        <CustomSelect className="date-ranges-custom-select " value={ props.value ?? "custom" } onChange={ onChange }>
            <CustomSelectItem value="custom">Custom</CustomSelectItem>
            <CustomSelectItem value="today">Today</CustomSelectItem>
            <CustomSelectItem value="yesterday">Yesterday</CustomSelectItem>
            <CustomSelectItem value="this week">This Week</CustomSelectItem>
            <CustomSelectItem value="last week">Last Week</CustomSelectItem>
            <CustomSelectItem value="this month">This Month</CustomSelectItem>
            <CustomSelectItem value="last month">Last Month</CustomSelectItem>
            <CustomSelectItem value="last 3 months">Last 3 Months</CustomSelectItem>
            <CustomSelectItem value="last 6 months">Last 6 Months</CustomSelectItem>
            <CustomSelectItem value="last 9 months">Last 9 Months</CustomSelectItem>
            <CustomSelectItem value="this year">This Year</CustomSelectItem>
            <CustomSelectItem value="last year">Last Year</CustomSelectItem>
            <CustomSelectItem value="all dates">All Dates</CustomSelectItem>
        </CustomSelect>
    );
}

/**
 * @name getDataObj
 * @return {OBJECT}
 * @property {STRING} value - A string value, like "custom", "today", "yesterday", ect.
 * @description - This is a utility function that returns an object with "fromDate" and "toDate" BCMSDate
 * objects used to populate the "Date Range" fields since thoes values vary considerably.
 */
export function getDateRangeObj(value) {
    const _value = value.toLowerCase();
    let dataObj = { fromDate: undefined, toDate: undefined, value: _value };

    switch(_value) {
        case "custom":
            dataObj.fromDate = BCMSDate.init().offset(-7);
            dataObj.toDate = undefined;
            break;
        case "today":
            dataObj.fromDate = BCMSDate.init();
            dataObj.toDate = BCMSDate.init();
            break;
        case "yesterday":
            dataObj.fromDate = BCMSDate.init().offset(-1);
            dataObj.toDate = BCMSDate.init().offset(-1);
            break;
        case "this week":
            var firstDayOfWeek = new Date();
            firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay());
            dataObj.fromDate = BCMSDate.init(firstDayOfWeek);
            dataObj.toDate = BCMSDate.init();
            break;
        case "last week":
            var firstDayOfWeek = new Date(); // First day of theweek is this past sunday.
            firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay());
            dataObj.fromDate = BCMSDate.init(firstDayOfWeek).offset(-7);
            dataObj.toDate = BCMSDate.init(firstDayOfWeek).offset(-1);
            break;
        case "this month":
            dataObj.fromDate = BCMSDate.init().setToFirst();
            dataObj.toDate = BCMSDate.init();
            break;
        case "last month":
            const firstDayLastMonth = BCMSDate.init().setToFirst();
            firstDayLastMonth.offset(-1).setToFirst();
            const lastDayLastMonth = BCMSDate.init().setToFirst();
            lastDayLastMonth.offset(-1);

            dataObj.fromDate = firstDayLastMonth;
            dataObj.toDate = lastDayLastMonth;
            break;
        case "last 3 months":
            const threeMonthsAgo = BCMSDate.init();
            threeMonthsAgo.month = threeMonthsAgo.monthInt - 3;

            dataObj.fromDate = threeMonthsAgo;
            dataObj.toDate = BCMSDate.init();
            break;
        case "last 6 months":
            const sixMonthsAgo = BCMSDate.init();
            sixMonthsAgo.month = sixMonthsAgo.monthInt - 6;

            dataObj.fromDate = sixMonthsAgo;
            dataObj.toDate = BCMSDate.init();
            break;
        case "last 9 months":
            const nineMonthsAgo = BCMSDate.init();
            nineMonthsAgo.month = nineMonthsAgo.monthInt - 9;

            dataObj.fromDate = nineMonthsAgo;
            dataObj.toDate = BCMSDate.init();
            break;
        case "this year":
            const januaryOfThisYear = BCMSDate.init();
            januaryOfThisYear.month = 1;
            januaryOfThisYear.setToFirst();

            dataObj.fromDate = januaryOfThisYear;
            dataObj.toDate = BCMSDate.init();
            break;
        case "last year":
            const januaryOfLastYear = BCMSDate.init();
            januaryOfLastYear.month = 1;
            januaryOfLastYear.setToFirst();
            januaryOfLastYear.offset(-1);
            januaryOfLastYear.month = 1;
            januaryOfLastYear.setToFirst();
            const decemberOfLastYear = BCMSDate.init();
            decemberOfLastYear.month = 1;
            decemberOfLastYear.setToFirst();
            decemberOfLastYear.offset(-1);

            dataObj.fromDate = januaryOfLastYear;
            dataObj.toDate = decemberOfLastYear;
            break;
        case "all dates":
            dataObj.fromDate = undefined;
            dataObj.toDate = undefined;
        default:
            break;
    };

    return dataObj;
}